import React from 'react'
import PackageModal from 'components/packages/modals/PackageModal'
import { useFlagRequirementCounts } from 'components/flags/hooks/useFlagRequirementCounts'
import { closePackageModal, openPackageModal } from 'lib/openPackageModal'

export default function AcknowledgmentReadyModal({ packageHashedId }) {
  const { incompleteCount, completeCount, total } = useFlagRequirementCounts()

  const handlePreview = () => {
    openPackageModal(packageHashedId, 'acknowledgement_preview').catch((error) => {
      console.error('[AcknowledgmentReadyModal] openPackageModal error', error)
    })
  }

  return (
    <PackageModal isOpen={true} onClose={closePackageModal}>
      <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-d-flex dome-flex-column dome-gap12">
          <span>
            <i
              style={{ fontSize: '42px', marginLeft: 10 }}
              className="fa-thin fa-clipboard-list-check dome-color-dark-green"
            />
          </span>
          <span className="dome-h2 dome-color-dark-green">acknowledgment ready to send</span>
        </div>
        <div className="dome-d-flex dome-flex-column dome-gap6">
          <span className="dome-h5 dome-color-darkest-grey">
            application status: <span className="dome-h5 dome-color-red-alert dome-text-w500">incomplete</span>
          </span>
          <div className="dome-d-flex">
            <div style={{ width: 87 }} className="dome-d-flex dome-flex-column dome-justify-start">
              <span className="dome-p3 dome-color-med-grey">incomplete</span>
              <span className="dome-h2 dome-color-dark-grey">{incompleteCount}</span>
            </div>
            <div style={{ width: 87 }} className="dome-d-flex dome-flex-column dome-justify-start">
              <span className="dome-p3 dome-color-med-grey">complete</span>
              <span className="dome-h2 dome-color-dark-grey">{completeCount}</span>
            </div>
          </div>
        </div>
        <div className="dome-d-flex dome-justify-between dome-align-center">
          <button
            type="button"
            onClick={closePackageModal}
            className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
          >
            still reviewing
          </button>

          <button type="button" onClick={handlePreview} className="dome-btn dome-btn-base dome-btn-dark-green">
            preview
          </button>
        </div>
      </div>
    </PackageModal>
  )
}
